import * as types from "../actions/types";



const initialState = {
  pageNumber: 0,
  pageCount: 0,
  count: 0,
  list: null,
  currentPeriod: {},
  loading: false,
  exclusions: [],
  exclusionsLoading: false,
  groups: []
};


export default function periods (state = initialState, action) {
  switch (action.type) {
    case types.SET_PERIODS_COUNT:
      return {
        ...state,
        ...action.payload
      };
    case types.SET_PERIODS_PAGE:
      return {
        ...state,
        pageNumber: action.payload
      };
    case types.SET_PERIODS_LIST:
      return {
        ...state,
        list: action.payload,
      };
    case types.SET_CURRENT_PERIOD:
      return {
        ...state,
        currentPeriod: action.payload
      };
    case types.SET_PERIODS_LOADING:
      return {
        ...state,
        loading: action.payload
      };
    case types.SET_PERIOD_EXCLUSIONS:
      return {
        ...state,
        exclusions: action.payload
      };
    case types.SET_PERIOD_EXCLUSIONS_LOADING:
      return {
        ...state,
        exclusionsLoading: action.payload
      };
    case types.SET_PERIOD_GROUPS:
      return {
        ...state,
        groups: action.payload
      };
    default:
      return state;
  }
}